export default __webpack_public_path__ + "static/media/jpeg.17316684.png";